import {
  FUSION,
  TRIO,
  DUO,
  ONLY_MOBILE,
  ONLY_PHONE,
  MOBILE_PREPAID,
  CATALOG_SECTIONS,
  rent2rent,
  BASIC_STEPPER_DATA,
  expensesText,
  link2ChooseSmartphoneUrlPikolin,
  HGU,
  r2rHiredTypes,
  ATTACHMENTS_TYPES_IMG_HIGH_RESOLUTION,
  CAT_NETFLIX,
  CAT_DISNEY,
  poIdsFttrPrincipal,
  poIdsFttrAdicional,
  SPECIFIC_CUSTOMER_PRODUCT_KINDS,
  FTTR_PO_CATEGORY,
  withCommitmentTermPrefix,
  PERMANENCE,
} from "@/constants/constants";

import {
  FIBER
} from '@/constants/setupBasics';
import { FIJO } from "@/constants/general-managment-constants";

import poLibrary from "@/constants/poLibrary";
// import { ICON_ID } from '@gerenciatd/next.components.icon';
import { getUrl } from "@/utils/commonUtils";
import { returnElemWithKeyAndValue } from "@/utils/dataHandler";
// import { getProductOfferingTextByType } from '@/utils/dataHandlers/CatalogueDataHandler';
import {
  chooseSmartphoneTitleModal,
  deviceNamePrefix,
  equipmentSubtitleAditionaldOrder,
  equipmentSubtitleIncludedOrder,
  inProcessOrder,
  othersPendingOrder,
  pendingMobileTitleModal,
} from "@/constants/textConstants";
import { getAccumulatedUsageByProductId } from "./UsageDataHandler";
import {
  getProductOfferingTextByType,
  normalizeBase64ImageToCss,
} from "./CatalogueDataHandler";
import { concatUrl } from "../htmlUtils";
import { idPosOcultarCuotaR2RIncluido } from "@/constants/constants";
import { TEXT_TYPES_CODES } from "@/constants/catalogue";
import { changeTelcoFormatToFrontFormat } from "../utils";
import {
  ALIAS_DAZN_ACTIVATION,
  ALIAS_DISNEY_ACTIVATION,
  ALIAS_HBO_MAX_ACTIVATION,
  MODULO_BUYBOX_CARACTERISTICS_ACTIVACION_DAZN_CREA,
  MODULO_BUYBOX_CARACTERISTICS_ACTIVACION_DISNEY_CREA,
  MODULO_BUYBOX_CARACTERISTICS_ACTIVACION_HBO_CREA,
  MODULO_BUYBOX_CARACTERISTICS_CUENTA_CREADA_DAZN,
  MODULO_BUYBOX_CARACTERISTICS_CUENTA_CREADA_DISNEY,
  MODULO_FAQS_ACTIVACION_DISNEY_CREA,
  MODULO_FAQS_CUENTA_CREADA_DISNEY,
  MODULO_BUYBOX_CARACTERISTICS_CUENTA_CREADA_HBO,
  MODULO_BUYBOX_CARACTERISTICS_SIN_CUENTA_DAZN,
  MODULO_BUYBOX_CARACTERISTICS_SIN_CUENTA_DISNEY,
  MODULO_BUYBOX_CARACTERISTICS_SIN_CUENTA_HBO,
  MODULO_FAQS_ACTIVACION_DAZN_CREA,
  MODULO_FAQS_CUENTA_CREADA_DAZN,
  MODULO_FAQS_ACTIVACION_HBO_CREA,
  ALIAS_SKYSHOWTIME_ACTIVATION,
  MODULO_BUYBOX_CARACTERISTICS_ACTIVACION_SKYSHOWTIME_CREA,
  MODULO_FAQS_ACTIVACION_SKYSHOWTIME_CREA,
  MODULO_BUYBOX_CARACTERISTICS_CUENTA_CREADA_SKYSHOWTIME,
  MODULO_BUYBOX_CARACTERISTICS_SIN_CUENTA_SKYSHOWTIME,
  MODULO_FAQS_CUENTA_CREADA_SKYSHOWTIME_CREA,
  AP_PRODUCT_CONTRATADOS_LIST_DISPOSITIVOS,
} from "@/constants/orion";
import { normalizeQuoteR2R } from "@/sagas/normalizers/productNormalizer";
import { USUARIO_PRIMER_R2R_INCLUIDO, USUARIO_R2R, USUARIO_R2R_ADICIONAL, USUARIO_R2R_ADICIONAL_REDIMIR, USUARIO_SEGUNDO_R2R_INCLUIDO } from "@/constants/get-my-products";
import { ENV_NAME } from "@gcloud-npm/utils.enums.environment";
import { SSO_PDB_URL_CERT, SSO_PDB_URL_PROD } from "@/constants/project-urls";
import { getAllInternet, getAllMobileLines } from "@/sagas/normalizers/generalManagmentNormalizer";
import { getEquipamientoProducts, getInternetProducts, getPrepagoLines, getProteccioDigitalIntegralProducts } from "@/containers/my-products/utils";
import { getProductContractsOfCertainPOTType } from "./ContractsDataHandler";
import { hasAnyCompatibleMobileLine } from "@/utils/dataHandlers/CerberusDataHandler";

export const getTvProductsDependency = (hiredProduct) => {
  const tvArray = [];
  if (hiredProduct.tv) {
    hiredProduct.tv.productosContratadosDedependientes.forEach((product) => {
      tvArray.push(product);
    });
  }
  return tvArray;
};

export const getPhoneProductsDependency = (hiredProduct) => {
  const phoneArray = [];
  if (
    hiredProduct?.phone?.linesPhone &&
    Array.isArray(hiredProduct.phone.linesPhone)
  ) {
    hiredProduct.phone.linesPhone.forEach((lines) => {
      const dependentProducts = lines?.productosContratadosDedependientes;
      if (Array.isArray(dependentProducts)) {
        dependentProducts.forEach((product) => {
          phoneArray.push(product);
        });
      }
    });
  }

  return phoneArray;
};

export const getMobileProductsDependency = (hiredProduct) => {
  const mobileArray = [];

  if (hiredProduct.mobile) {
    hiredProduct.mobile.linesMobile.forEach((lines) => {
      lines.productosContratadosDedependientes.forEach((product) => {
        mobileArray.push(product);
      });
    });
  }

  return mobileArray;
};

export const getInternetProductsDependency = (hiredProduct) => {
  const internetArray = [];
  if (hiredProduct.internet) {
    hiredProduct.internet.productosContratadosDedependientes.forEach(
      (product) => {
        internetArray.push(product);
      }
    );
  }
  return internetArray;
};

export const getFirstProductByPoIdOnCertainProduct = (
  productStructure,
  poIds
) => {
  let product = null;
  if (productStructure) {
    if (
      poIds.includes(productStructure.poId) ||
      poIds.includes(productStructure.bundleId)
    ) {
      product = productStructure;
    }
    const { internet, mobile, phone, tv } = productStructure;
    if (internet && !product) {
      if (poIds.includes(internet.poId) || poIds.includes(internet.bundleId)) {
        product = internet;
      } else {
        const productFound = getInternetProductsDependency(
          productStructure
        ).find((x) => poIds.includes(x.poId) || poIds.includes(x.bundleId));
        if (productFound) {
          product = productFound;
        }
      }
    }
    if (mobile && !product) {
      const { linesMobile } = mobile;
      if (linesMobile && Array.isArray(linesMobile)) {
        const productFound = linesMobile.find(
          (x) => poIds.includes(x.poId) || poIds.includes(x.bundleId)
        );
        if (productFound) {
          product = productFound;
        }
      }
      if (!product) {
        const productFound = getMobileProductsDependency(productStructure).find(
          (x) => poIds.includes(x.poId) || poIds.includes(x.bundleId)
        );
        if (productFound) {
          product = productFound;
        }
      }
    }
    if (phone && !product) {
      const { linesPhone } = phone;
      if (linesPhone && Array.isArray(linesPhone)) {
        const productFound = linesPhone.find(
          (x) => poIds.includes(x.poId) || poIds.includes(x.bundleId)
        );
        if (productFound) {
          product = productFound;
        }
      }
      if (!product) {
        const productFound = getPhoneProductsDependency(productStructure).find(
          (x) => poIds.includes(x.poId) || poIds.includes(x.bundleId)
        );
        if (productFound) {
          product = productFound;
        }
      }
    }
    if (tv && !product) {
      if (poIds.includes(tv.poId) || poIds.includes(tv.bundleId)) {
        product = tv;
      } else {
        const productFound = getTvProductsDependency(productStructure).find(
          (x) => poIds.includes(x.poId) || poIds.includes(x.bundleId)
        );
        if (productFound) {
          product = productFound;
        }
      }
    }
  }
  return product;
};

export const getProductByPOId = (hiredProducts, poId) => {
  let product = hiredProducts.find(
    (x) => x.poId === poId || x.bundleId === poId
  );
  if (!product) {
    hiredProducts.forEach((hiredProduct) => {
      const { internet, mobile, phone, tv } = hiredProduct;
      if (internet) {
        if (internet.poId === poId) {
          product = internet;
        } else {
          const productFound = getInternetProductsDependency(hiredProduct).find(
            (x) => x.poId === poId || x.bundleId === poId
          );
          if (productFound) {
            product = productFound;
          }
        }
      }
      if (mobile && !product) {
        const { linesMobile } = mobile;
        if (linesMobile && Array.isArray(linesMobile)) {
          const productFound = linesMobile.find(
            (x) => x.poId === poId || x.bundleId === poId
          );
          if (productFound) {
            product = productFound;
          }
        }
        if (!product) {
          const productFound = getMobileProductsDependency(hiredProduct).find(
            (x) => x.poId === poId || x.bundleId === poId
          );
          if (productFound) {
            product = productFound;
          }
        }
      }
      if (phone && !product) {
        const { linesPhone } = phone;
        if (linesPhone && Array.isArray(linesPhone)) {
          const productFound = linesPhone.find(
            (x) => x.poId === poId || x.bundleId === poId
          );
          if (productFound) {
            product = productFound;
          }
        }
        if (!product) {
          const productFound = getPhoneProductsDependency(hiredProduct).find(
            (x) => x.poId === poId || x.bundleId === poId
          );
          if (productFound) {
            product = productFound;
          }
        }
      }
      if (tv && !product) {
        if (tv.poId === poId) {
          product = tv;
        } else {
          const productFound = getTvProductsDependency(hiredProduct).find(
            (x) => x.poId === poId || x.bundleId === poId
          );
          if (productFound) {
            product = productFound;
          }
        }
      }
    });
  }
  return product;
};

export const filterSubsectionAndProductType = (
  product,
  subsection,
  productType
) => {
  if (subsection && !productType) {
    return product.subseccion === subsection;
  }
  if (!subsection && productType) {
    return product.productType === productType;
  }
  if (subsection && productType) {
    return (
      product.subseccion === subsection && product.productType === productType
    );
  }
  return null;
};

export const getProductsBySubSection = (
  hiredProducts,
  subsection,
  deepSearch = true
) => {
  let arraySectionProducts = hiredProducts.filter(
    (x) => x.subseccion === subsection
  );
  if (deepSearch) {
    hiredProducts.forEach((hiredProduct) => {
      const mobileDependecy = getMobileProductsDependency(hiredProduct).filter(
        (x) => x.subseccion === subsection
      );
      arraySectionProducts = [
        ...new Set([...arraySectionProducts, ...mobileDependecy]),
      ];
      const phoneDependecy = getPhoneProductsDependency(hiredProduct).filter(
        (x) => x.subseccion === subsection
      );
      arraySectionProducts = [
        ...new Set([...arraySectionProducts, ...phoneDependecy]),
      ];
      const internetDependecy = getInternetProductsDependency(
        hiredProduct
      ).filter((x) => x.subseccion === subsection);
      arraySectionProducts = [
        ...new Set([...arraySectionProducts, ...internetDependecy]),
      ];
      const tvDependecy = getTvProductsDependency(hiredProduct).filter(
        (x) => x.subseccion === subsection
      );
      arraySectionProducts = [
        ...new Set([...arraySectionProducts, ...tvDependecy]),
      ];
    });
  }
  return arraySectionProducts;
};

/**
 * Devuelve una lista segun la subseccion y el productType
 * @param {string} hiredProducts -> Productos
 * @param {string} subsection -> subseccion (opcional)
 * @param {number} productType -> productType (opcional)
 * @param {boolean} deepSearch -> si es true busca en todos los productos
 * @returns {Array} URL a la que hacer la request
 */
export const getProductsBySubSectionAndProductType = ({
  hiredProducts,
  subsection,
  productType,
  deepSearch,
}) => {
  let arraySectionProducts = hiredProducts.filter((product) => {
    return filterSubsectionAndProductType(product, subsection, productType);
  });
  if (deepSearch) {
    hiredProducts.forEach((hiredProduct) => {
      const mobileDependecy = getMobileProductsDependency(hiredProduct).filter(
        (product) => {
          return filterSubsectionAndProductType(
            product,
            subsection,
            productType
          );
        }
      );
      arraySectionProducts = [
        ...new Set([...arraySectionProducts, ...mobileDependecy]),
      ];
      const phoneDependecy = getPhoneProductsDependency(hiredProduct).filter(
        (product) => {
          return filterSubsectionAndProductType(
            product,
            subsection,
            productType
          );
        }
      );
      arraySectionProducts = [
        ...new Set([...arraySectionProducts, ...phoneDependecy]),
      ];
      const internetDependecy = getInternetProductsDependency(
        hiredProduct
      ).filter((product) => {
        return filterSubsectionAndProductType(product, subsection, productType);
      });
      arraySectionProducts = [
        ...new Set([...arraySectionProducts, ...internetDependecy]),
      ];
      const tvDependecy = getTvProductsDependency(hiredProduct).filter(
        (product) => {
          return filterSubsectionAndProductType(
            product,
            subsection,
            productType
          );
        }
      );
      arraySectionProducts = [
        ...new Set([...arraySectionProducts, ...tvDependecy]),
      ];
    });
  }
  return arraySectionProducts;
};

export const getTitleCommunication = (bundleProduct) => {
  let title = "";

  switch (bundleProduct) {
    case FUSION:
      title = "Internet, fijo y móvil";
      break;
    case TRIO:
    case DUO:
      title = "Internet y fijo";
      break;
    case ONLY_MOBILE:
      title = "Móvil";
      break;
    case MOBILE_PREPAID:
      title = "Móvil prepago";
      break;
    case ONLY_PHONE:
      title = "Fijo";
      break;
    default:
      title = "";
      break;
  }
  return title;
};

export const getAllCommunicationCount = (hiredProducts) => {
  let result = 0;
  hiredProducts.forEach((element) => {
    const { productType } = element;
    if (
      [FUSION, TRIO, DUO, ONLY_MOBILE, ONLY_PHONE, MOBILE_PREPAID].indexOf(
        productType
      ) !== -1
    ) {
      result += 1;
      if (element.mobile && element.mobile.linesMobile) {
        element.mobile.linesMobile.forEach(() => {
          result += 1;
        });
      }
      if (element.phone && element.phone.linesPhone) {
        element.phone.linesPhone.forEach(() => {
          result += 1;
        });
      }
    }
  });
  return result;
};

export const getCommunicationsProducts = (
  hiredProducts,
  bundleProduct,
  urlLibrary
) => {
  const items = [];
  if ([FUSION, TRIO, DUO].indexOf(bundleProduct) !== -1) {
    const bundleProductItem = hiredProducts.find(
      (element) => element.productType === bundleProduct
    );
    if (bundleProductItem) {
      const objTemp = {
        poId:
          (bundleProductItem.internet && bundleProductItem.internet.poId) ||
          bundleProductItem.poId,
        url: `/misProductos/detalle/internet/${bundleProductItem.productId}`,
        idIcon: "Wifi",
        mainText: "Internet",
      };
      items.push(objTemp);
    }
  }

  hiredProducts.forEach((element) => {
    if (element.mobile && element.mobile.linesMobile) {
      element.mobile.linesMobile.forEach((lineMobile) => {
        const isPrepay = element.productType === MOBILE_PREPAID;
        const url = !isPrepay
          ? `${getUrl("Consumo", urlLibrary)}/movil/${lineMobile.productId}`
          : `${getUrl("usageDetailsPrepay", urlLibrary)}/movil/${
              lineMobile.productId
          }/0`;
        const objTemp = {
          poId: lineMobile.poId,
          url,
          idIcon: "Movil",
          mainText: lineMobile.number,
        };
        items.push(objTemp);
      });
    }
    if (element.phone && element.phone.linesPhone) {
      element.phone.linesPhone.forEach((linePhone) => {
        const objTemp = {
          poId: linePhone.poId,
          url: `/misProductos/consumo/fijo/${linePhone.productId}`,
          idIcon: "Fijo",
          mainText: linePhone.number,
        };

        items.push(objTemp);
      });
    }
  });
  return items;
};

export const getEntertainmentProducts = (hiredProducts) => {
  const items = [];

  hiredProducts.forEach((hiredProduct) => {
    if (hiredProduct.tv) {
      const objTemp = {
        poId: hiredProduct.tv.poId,
        url: `/misProductos/detalle/tv/${hiredProduct.productId}`,
        idIcon: "",
        mainText: hiredProduct.tv.description,
      };
      items.push(objTemp);
    }
  });
  if (items.length === 1) {
    items[0].urlFooter = items[0].url;
    items[0].url = null;
  }
  return items;
};
export const getR2RProducts = (
  hiredProducts,
  infoEquipment = null,
  urlLibrary
) => {
  const items = [];

  const filter = getProductsBySubSectionAndProductType({
    hiredProducts,
    // subsection: CATALOG_SECTIONS.VERTICALS.SUB_SECTIONS.COMMUNICATIONS,
    productType: BASIC_STEPPER_DATA.SUMMARY_R2R,
    deepSearch: true,
  });

  if (filter) {
    filter.forEach((product) => {
      const objTemp = {
        poId: product.poId,
        url: product?.categorias?.tipoDispositivo
          ? `${getUrl("Detail", urlLibrary)}?productId=${product.productId}`
          : null,
        idIcon:
          product?.categorias?.tipoDispositivo === rent2rent.devicesTypeR2R ||
            product?.categorias?.tipoDispositivo ===
            rent2rent.devicesTypeAdditionalR2R
            ? ""
            : "Multipantalla",
        mainText: "",
        type:
          product?.categorias?.tipoDispositivo === rent2rent.devicesTypeR2R ||
            product?.categorias?.tipoDispositivo ===
            rent2rent.devicesTypeAdditionalR2R
            ? "device"
            : "equipment",
      };
      items.push(objTemp);
    });
  }
  if ((!Array.isArray(filter) || filter.length < 2) && infoEquipment) {
    if (
      infoEquipment.inProgressWithRent2Rent ||
      infoEquipment.inProgressWithAdditionalRent2Rent
    ) {
      const objTemp = {
        label: pendingMobileTitleModal,
        mainText: inProcessOrder,
        subText: othersPendingOrder,
        themeLabel: "success",
        poId: "",
        url: "",
        idIcon: "Movil",
        type: "device",
        onClick: () => infoEquipment.onClick(true),
      };
      items.push(objTemp);
    }
    if (infoEquipment.isRent2Rent) {
      const objTemp = {
        label: chooseSmartphoneTitleModal,
        mainText: deviceNamePrefix,
        subText: equipmentSubtitleIncludedOrder,
        themeLabel: "warning",
        poId: "",
        url: "",
        idIcon: "Movil",
        type: "device",
        onClick: () => infoEquipment.onClick(false),
      };
      items.push(objTemp);
    } else if (infoEquipment.isRent2RentAdditional) {
      const objTemp = {
        label: chooseSmartphoneTitleModal,
        mainText: deviceNamePrefix,
        subText: equipmentSubtitleAditionaldOrder,
        themeLabel: "warning",
        poId: "",
        url: "",
        idIcon: "Movil",
        type: "device",
        onClick: () => infoEquipment.onClick(false),
      };
      items.push(objTemp);
    }
  }
  return items;
};

export const isFusionWithMobileRent2RentContracted = (product) => {
  let mobileRent2Rent = false;
  let mobileAdditionalRent2Rent = false;
  if (product && product.productType === FUSION && product.mobile) {
    product.mobile.linesMobile.forEach((lines) => {
      const fusionWithMobileRent2Rent =
        lines.productosContratadosDedependientes &&
        lines.productosContratadosDedependientes.find(
          (hiredProduct) =>
            (hiredProduct.categorias &&
              hiredProduct.categorias.tipoDispositivo ===
              rent2rent.devicesTypeR2R) === true
        );
      const fusionWithMobileAdditionalRent2Rent =
        lines.productosContratadosDedependientes &&
        lines.productosContratadosDedependientes.find(
          (hiredProduct) =>
            (hiredProduct.categorias &&
              hiredProduct.categorias.tipoDispositivo ===
              rent2rent.devicesTypeAdditionalR2R) === true
        );
      if (fusionWithMobileRent2Rent) {
        mobileRent2Rent = fusionWithMobileRent2Rent;
      }
      if (fusionWithMobileAdditionalRent2Rent) {
        mobileAdditionalRent2Rent = fusionWithMobileAdditionalRent2Rent;
      }
    });
  }
  if (!mobileRent2Rent) {
    mobileRent2Rent =
      product &&
      product.categorias &&
      product.categorias.tipoDispositivo === rent2rent.devicesTypeR2R &&
      product;
  }
  if (!mobileAdditionalRent2Rent) {
    mobileAdditionalRent2Rent =
      product &&
      product.categorias &&
      product.categorias.tipoDispositivo ===
      rent2rent.devicesTypeAdditionalR2R &&
      product;
  }
  return { mobileRent2Rent, mobileAdditionalRent2Rent };
};

export const hasAnyProductsWithMobileRent2RentContracted = (
  hiredProducts,
  sellingTypes = null
) => {
  let hasMobileRent2Rent = false;
  let hasMobileAddiotionalRent2Rent = false;
  let canContractMoreAditional = false;
  const mobilesIncludedRent2Rent = [];
  const mobilesAditionalRent2Rent = [];
  if (sellingTypes && sellingTypes.adicional) {
    canContractMoreAditional = sellingTypes.adicional.availableForPurchase;
  }
  if (Array.isArray(hiredProducts) && hiredProducts.length > 0) {
    hiredProducts.forEach((product) => {
      const { mobileRent2Rent, mobileAdditionalRent2Rent } =
        isFusionWithMobileRent2RentContracted(product);
      if (mobileRent2Rent) {
        hasMobileRent2Rent = mobileRent2Rent;
        mobilesIncludedRent2Rent.push(mobileRent2Rent);
      }
      if (mobileAdditionalRent2Rent) {
        hasMobileAddiotionalRent2Rent = mobileAdditionalRent2Rent;
        mobilesAditionalRent2Rent.push(mobileAdditionalRent2Rent);
      }
    });
  }
  return {
    hasMobileRent2Rent,
    hasMobileAddiotionalRent2Rent,
    canContractMoreAditional,
    mobilesIncludedRent2Rent,
    mobilesAditionalRent2Rent,
  };
};
export const hasUpgradeInternetSpeed = (currentProduct) => {
  let linkSpeedTitle = "Aumenta tu velocidad";
  if (currentProduct) {
    // currentProduct.compatibleUpgrade = true;
    const speed =
      currentProduct.internet && currentProduct.internet.downloadSpeed;
    const upgrade1Gb = currentProduct.compatibleUpgrade && speed === "600";
    const upgrade300Mb = currentProduct.compatibleUpgrade && speed === "100";
    if (upgrade1Gb) {
      linkSpeedTitle = "Sube hasta 1 Gb";
    } else if (upgrade300Mb) {
      linkSpeedTitle = "Sube a 300 Mb";
    }
    return {
      upgrade1Gb,
      upgrade300Mb,
      linkSpeedTitle,
    };
  }
  return null;
};
export const getBundleFromMobileProductId = (hiredProducts, productId) => {
  let bundleRes = null;
  hiredProducts.forEach((bundle) => {
    const { mobile } = bundle;
    if (mobile && bundle.mobile && bundle.mobile.linesMobile && !bundleRes) {
      const { linesMobile } = mobile;
      linesMobile.forEach((itemLine) => {
        // console.log('bundle', itemLine.productId, productId, !bundleRes)
        if (itemLine.productId === productId && !bundleRes) {
          bundleRes = bundle;
        }
      });
    }
  });
  return bundleRes;
};
export const getMobileFromMobileProductId = (hiredProducts, productId) => {
  const bundle = getBundleFromMobileProductId(hiredProducts, productId);
  if (bundle && bundle.mobile && bundle.mobile.linesMobile) {
    return bundle.mobile.linesMobile.find((x) => x.productId === productId);
  }
  return null;
};
export const getBonusByProductId = (hiredProducts, productId) => {
  const mobile = getMobileFromMobileProductId(hiredProducts, productId);
  let bonusFinal = null;
  if (mobile && mobile.bonus) {
    bonusFinal = mobile.bonus;
  }
  return bonusFinal;
};

export const getBundleFromPhoneProductId = (hiredProducts, productId) => {
  let bundleRes = null;
  hiredProducts.forEach((bundle) => {
    const { phone } = bundle;
    if (phone && bundle.phone && bundle.phone.linesPhone && !bundleRes) {
      const { linesPhone } = phone;
      linesPhone.forEach((itemLine) => {
        if (itemLine.productId === productId && !bundleRes) {
          bundleRes = bundle;
        }
      });
    }
  });
  return bundleRes;
};

export const getPhoneFromPhoneProductId = (hiredProducts, productId) => {
  const bundle = getBundleFromPhoneProductId(hiredProducts, productId);
  if (bundle && bundle.phone && bundle.phone.linesPhone) {
    return bundle.phone.linesPhone.find((x) => x.productId === productId);
  }
  return null;
};

export const getPhoneBonusAndServices = (hiredProducts, productId) => {
  const phone = getPhoneFromPhoneProductId(hiredProducts, productId);
  let products = null;
  if (phone && phone.productosContratadosDedependientes) {
    products = phone.productosContratadosDedependientes;
  }
  return products;
};

export const isActivate30GbPromo = (hiredProduct) => {
  let activate30GbBonu = false;
  hiredProduct.forEach((product) => {
    if (product.mobile && product.mobile.linesMobile) {
      product.mobile.linesMobile.forEach((line) => {
        if (line && line.bonus) {
          line.bonus.forEach((bonu) => {
            if (
              bonu.free &&
              bonu.productOffering === poLibrary.bonuPromo30GB &&
              bonu.promoted
            ) {
              activate30GbBonu = true;
            }
          });
        }
      });
    }
  });
  return activate30GbBonu;
};

export const has30GbPromoHiredByBonus = (bonus) => {
  // Si  viene promote a true
  let has30GbPromoActivate = false;
  if (bonus) {
    bonus.forEach((bonu) => {
      if (
        bonu.free &&
        bonu.productOffering === poLibrary.bonuPromo30GB &&
        bonu.productId
      ) {
        has30GbPromoActivate = true;
      }
    });
  }

  return has30GbPromoActivate;
};

export const hasLine5GbPromoHired = (bonus) => {
  // Si  viene promote a true
  let has5GbPromoActivate = false;
  if (bonus) {
    bonus.forEach((bonu) => {
      if (
        bonu.free &&
        bonu.productOffering === poLibrary.bonuPromo5GB &&
        bonu.productId
      ) {
        has5GbPromoActivate = true;
      }
    });
  }
  return has5GbPromoActivate;
};
export const hasUnlimitedBonu = (bonus) => {
  let isAvaibleToContractUnlimitedBonu = false;
  let isContractedUnlimitedBonu = false;
  if (bonus && bonus.length > 0) {
    bonus.forEach((bonu) => {
      if (bonu.productOffering === poLibrary.bonuUnlimited) {
        isAvaibleToContractUnlimitedBonu = true;
        if (bonu.productId) {
          isAvaibleToContractUnlimitedBonu = false;
          isContractedUnlimitedBonu = true;
        }
      }
    });
  }
  return {
    isAvaibleToContractUnlimitedBonu,
    isContractedUnlimitedBonu,
  };
};
export const getArrayElementById = (array, id) => {
  const result =
    array &&
    array.find((item) => {
      return item.id === id;
    });
  return result;
};

export const getProductByProductId = (hiredProducts, productId) => {
  let product = hiredProducts.find((x) => x.productId === productId);
  if (!product) {
    hiredProducts.forEach((hiredProduct) => {
      const { internet, mobile, phone, tv } = hiredProduct;
      if (phone && !product) {
        const { linesPhone } = phone;
        if (linesPhone && Array.isArray(linesPhone)) {
          const productFound = linesPhone.find(
            (x) => x.productId === productId
          );
          if (productFound) {
            product = productFound;
          }
        }
        if (!product) {
          const productFound = getPhoneProductsDependency(hiredProduct).find(
            (x) => x.productId === productId
          );
          if (productFound) {
            product = productFound;
          }
        }
      }
      if (internet && !product) {
        if (internet.productId === productId) {
          product = internet;
        } else {
          const productFound = getInternetProductsDependency(hiredProduct).find(
            (x) => x.productId === productId
          );
          if (productFound) {
            product = productFound;
          }
        }
      }
      if (mobile && !product) {
        const { linesMobile } = mobile;
        if (linesMobile && Array.isArray(linesMobile)) {
          const productFound = linesMobile.find(
            (x) => x.productId === productId
          );
          if (productFound) {
            product = productFound;
          }
        }
        if (!product) {
          const productFound = getMobileProductsDependency(hiredProduct).find(
            (x) => x.productId === productId
          );
          if (productFound) {
            product = productFound;
          }
        }
      }
      if (tv && !product) {
        if (tv.productId === productId) {
          product = tv;
        } else {
          const productFound = getTvProductsDependency(hiredProduct).find(
            (x) => x.productId === productId
          );
          if (productFound) {
            product = productFound;
          }
        }
      }
    });
  }

  return product;
};
export const getProductAndDadByProductId = (hiredProducts, productId) => {
  let productRes = null;
  let dadId;
  let currentProductRest = null;
  const numberOfProducts = hiredProducts.length;
  for (let p = 0; p < numberOfProducts; p += 1) {
    const currentDadProduct = hiredProducts[p];
    dadId = currentDadProduct.productId;
    // mobile
    if (
      typeof currentDadProduct.mobile !== "undefined" &&
      currentDadProduct.mobile !== null
    ) {
      if (
        typeof currentDadProduct.mobile.linesMobile !== "undefined" &&
        currentDadProduct.mobile.linesMobile !== null
      ) {
        const currentProduct = returnElemWithKeyAndValue(
          currentDadProduct.mobile.linesMobile,
          "productId",
          productId
        );
        if (currentProduct !== null) {
          currentProduct.kindProduct = "mobile";
          productRes = currentProduct;
          currentProductRest = currentDadProduct;
          break;
        }
      }
    }
    // phones
    if (
      typeof currentDadProduct.phone !== "undefined" &&
      currentDadProduct.phone !== null
    ) {
      if (
        typeof currentDadProduct.phone.linesPhone !== "undefined" &&
        currentDadProduct.phone.linesPhone !== null
      ) {
        const currentProduct = returnElemWithKeyAndValue(
          currentDadProduct.phone.linesPhone,
          "productId",
          productId
        );
        if (currentProduct !== null) {
          currentProduct.kindProduct = "phone";
          productRes = currentProduct;
          currentProductRest = currentDadProduct;
          break;
        }
      }
    }
    // internet
    if (
      typeof currentDadProduct.internet !== "undefined" &&
      currentDadProduct.internet !== null
    ) {
      const currentProduct = currentDadProduct.internet;
      if (
        typeof currentDadProduct.internet.productId !== "undefined" &&
        currentDadProduct.internet.productId !== null
      ) {
        if (currentDadProduct.internet.productId === productId) {
          currentProduct.kindProduct = "internet";
          productRes = currentProduct;
          currentProductRest = currentDadProduct;
          break;
        }
      }
    }
    // tv
    if (
      typeof currentDadProduct.tv !== "undefined" &&
      currentDadProduct.tv !== null
    ) {
      const currentProduct = currentDadProduct.tv;
      if (
        typeof currentDadProduct.tv.productId !== "undefined" &&
        currentDadProduct.tv.productId !== null
      ) {
        if (currentDadProduct.tv.productId === productId) {
          currentProduct.kindProduct = "tv";
          productRes = currentProduct;
          currentProductRest = currentDadProduct;
          break;
        }
      }
    }
  }
  return {
    product: productRes,
    dadId,
    currentProductRest,
  };
};

export const getCurrentContestByType = (contestInfo, contestType) => {
  let currentContest = null;
  if (Array.isArray(contestInfo) && contestInfo.length > 0) {
    currentContest = contestInfo.find(
      (contest) => contest.idConcurso === contestType
    );
  }
  return currentContest;
};

export const getLinesMobileFromHiredProducts = (hiredProducts) => {
  const linesMobiles = [];
  hiredProducts.forEach((product) => {
    if (product.mobile && product.mobile.linesMobile) {
      linesMobiles.push(product.mobile.linesMobile);
    }
  });
  return [...new Set([].concat(...linesMobiles))];
};

export const getLinesPhoneFromHiredProducts = (hiredProducts) => {
  const linesPhone = [];
  hiredProducts.forEach((product) => {
    if (product.phone && product.phone.linesPhone) {
      linesPhone.push(product.phone.linesPhone);
    }
  });
  return [...new Set([].concat(...linesPhone))];
};

export const getTvsFromHiredProducts = (hiredProducts) => {
  const tvs = [];
  hiredProducts.forEach((product) => {
    if (product.tv) {
      tvs.push(product.tv);
    }
  });
  return [...new Set([].concat(...tvs))];
};

export const getLinesPhoneMobilesFusionFromHiredProducts = (hiredProducts) => {
  const lines = [];
  hiredProducts.forEach((product) => {
    if (product.phone && product.phone.linesPhone) {
      const { linesPhone } = product.phone;
      linesPhone.forEach((linePhone) => {
        lines.push(linePhone);
      });
    }
    if (product.mobile && product.mobile.linesMobile) {
      const { linesMobile } = product.mobile;
      linesMobile.forEach((lineMobile) => {
        lines.push(lineMobile);
      });
    }
  });
  return lines;
};

export const getInternetFromHiredProducts = (hiredProducts) => {
  const internets = [];
  hiredProducts.forEach((product) => {
    if (product.internet) {
      internets.push(product.internet);
    }
  });
  return internets;
};

export const getAllBonusFromHiredProducts = (hiredProducts) => {
  const linesMobiles = getLinesMobileFromHiredProducts(hiredProducts);
  const bonus = [];
  linesMobiles.forEach((line) => {
    if (line && line.bonus) {
      bonus.push(line.bonus);
    }
  });
  return [...new Set([].concat(...bonus))];
};

export const getAllContractedBonusFromHiredProducts = (hiredProducts) => {
  const bonus = getAllBonusFromHiredProducts(hiredProducts);
  if (bonus[0] === undefined) {
    return null;
  }
  const contractedBonus = bonus.filter((x) => x.productId !== null);
  return contractedBonus;
};

export const getAllContractedPayBonusFromHiredProducts = (hiredProducts) => {
  const contractedBonus = getAllContractedBonusFromHiredProducts(hiredProducts);
  if (!contractedBonus) {
    return null;
  }
  const contractedPayBonus = contractedBonus.filter((x) => x.free === false);
  return contractedPayBonus;
};

export const getContractedFromMobileProductId = (hiredProducts, productId) => {
  const mobile = getMobileFromMobileProductId(hiredProducts, productId);
  if (mobile) {
    const { bonus } = mobile;
    let contractedBonus = null;
    if (bonus) {
      contractedBonus = bonus.filter((x) => x.productId !== null);
    }
    return contractedBonus;
  }
  return null;
};

export const getContractedPayFromMobileProductId = (
  hiredProducts,
  productId
) => {
  const contractedBonus = getContractedFromMobileProductId(
    hiredProducts,
    productId
  );
  if (contractedBonus) {
    const contractedPayBonus = contractedBonus.filter((x) => x.free === false);
    return contractedPayBonus;
  }
  return null;
};

export const isRent2RentByProductId = (isR2RAvailableToPurchase) => {
  let isRent2Rent = false;
  let isRent2RentAdditional = false;
  if (isR2RAvailableToPurchase) {
    isRent2Rent = isR2RAvailableToPurchase.incluido?.availableForPurchase;
    isRent2RentAdditional =
      isR2RAvailableToPurchase.adicional?.availableForPurchase;
  }
  return { isRent2Rent, isRent2RentAdditional };
};

export const getTextByProduct = (product) => {
  switch (product) {
    case "tv":
      return expensesText.tv;
    case "mobile":
      return expensesText.mobile;
    case "internet":
      return expensesText.internet;
    case "phone":
      return expensesText.phone;
    default:
      // It's a number
      return `Línea  ${product}`;
  }
};
export const hasDisneyCompatibility = (
  arrayDisney,
  productId = null,
  dependantIds = []
) => {
  if (productId && arrayDisney && arrayDisney.length > 0) {
    let dependienteFound = false;
    let dependienteFoundReturn = null;
    dependantIds.forEach((product) => {
      const disneyDependant = arrayDisney.find(
        (item) => item.productId === product
      );
      if (disneyDependant) {
        dependienteFound = true;
        dependienteFoundReturn = disneyDependant.compatibilidad;
        return disneyDependant.compatibilidad;
      }
      return false;
    });
    if (dependienteFound) {
      return dependienteFoundReturn;
    }
    const disney = arrayDisney.find((item) => item.productId === productId);
    return disney && disney.compatibilidad;
  }
  if (arrayDisney && arrayDisney.length > 0) {
    const disney = arrayDisney.find((item) => item.compatibilidad === true);
    return !!disney;
  }
  return false;
};

export const hasDisneyActivated = (
  arrayDisney,
  productId = null,
  dependantIds = []
) => {
  if (productId && arrayDisney && arrayDisney.length > 0) {
    let dependienteFound = false;
    let dependienteFoundReturn = null;
    dependantIds.forEach((product) => {
      const disneyDependant = arrayDisney.find(
        (item) => item.productId === product
      );
      if (disneyDependant) {
        dependienteFound = true;
        dependienteFoundReturn = disneyDependant.estado === "A";
        return disneyDependant.estado === "A";
      }
      return false;
    });
    if (dependienteFound) {
      return dependienteFoundReturn;
    }
    const disney = arrayDisney.find((item) => item.productId === productId);
    return disney && disney.estado === "A";
  }
  if (arrayDisney && arrayDisney.length > 0) {
    const disney = arrayDisney.find((item) => item.estado === "A");
    return !!disney;
  }
  return false;
};

export const hasProviderCompatibility = (
  providersCompatibility,
  provider,
  productId = null,
  dependantIds = []
) => {
  const providerCompatibility =
    providersCompatibility &&
    providersCompatibility[provider] &&
    providersCompatibility[provider].compatibles;
  if (
    Array.isArray(providerCompatibility) &&
    providerCompatibility.length > 0 &&
    productId
  ) {
    let dependienteFound = false;
    let dependienteFoundReturn = null;
    dependantIds.forEach((product) => {
      const currentProviderDependant = providerCompatibility.find(
        (item) => item.productId === product
      );
      if (currentProviderDependant) {
        dependienteFound = true;
        dependienteFoundReturn = currentProviderDependant.compatibilidad;
        return currentProviderDependant.compatibilidad;
      }
      return false;
    });
    if (dependienteFound) {
      return dependienteFoundReturn;
    }
    const currentProvider = providerCompatibility.find(
      (item) => item.productId === productId
    );
    return currentProvider && currentProvider.compatibilidad;
  }
  if (
    Array.isArray(providerCompatibility) &&
    providerCompatibility.length > 0
  ) {
    const currentProvider = providerCompatibility.find(
      (item) => item.compatibilidad === true
    );
    return !!currentProvider;
  }
  return false;
};

export const hasProviderCompatibilityCapa = (
  providerStatus,
  provider,
  productId = null,
  dependantIds = []
) => {
  const providerCompatibility =
    providerStatus &&
    providerStatus[provider] &&
    providerStatus[provider].compatibleProducts;
  if (
    Array.isArray(providerCompatibility) &&
    providerCompatibility.length > 0 &&
    productId
  ) {
    let dependienteFound = false;
    let dependienteFoundReturn = null;
    dependantIds.forEach((product) => {
      const currentProviderDependant = providerCompatibility.find(
        (item) => item.productId === product
      );
      if (currentProviderDependant) {
        dependienteFound = true;
        dependienteFoundReturn = currentProviderDependant;
        return currentProviderDependant;
      }
      return false;
    });
    if (dependienteFound) {
      return dependienteFoundReturn;
    }
    const currentProvider = providerCompatibility.find(
      (item) => item.productId === productId
    );
    return currentProvider;
  }
  if (
    Array.isArray(providerCompatibility) &&
    providerCompatibility.length > 0
  ) {
    const currentProvider = providerCompatibility.find(
      (item) => item.compatibilidad === true
    );
    return !!currentProvider;
  }
  return false;
};

export const getAliasByProvider = (provider) => {
  let alias = "";
  let aliasActivacion = "";
  let aliasActivacionFaqs = "";
  let aliasCuentaCreada = "";
  let aliasSinCuenta = "";
  let aliasCuentaCreadaFaqs = "";
  switch (provider) {
    case "disney":
      alias = ALIAS_DISNEY_ACTIVATION;
      aliasActivacion = MODULO_BUYBOX_CARACTERISTICS_ACTIVACION_DISNEY_CREA;
      aliasActivacionFaqs = MODULO_FAQS_ACTIVACION_DISNEY_CREA;
      aliasCuentaCreada = MODULO_BUYBOX_CARACTERISTICS_CUENTA_CREADA_DISNEY;
      aliasCuentaCreadaFaqs = MODULO_FAQS_CUENTA_CREADA_DISNEY;
      aliasSinCuenta = MODULO_BUYBOX_CARACTERISTICS_SIN_CUENTA_DISNEY;
      break;
    case "dazn":
      alias = ALIAS_DAZN_ACTIVATION;
      aliasActivacion = MODULO_BUYBOX_CARACTERISTICS_ACTIVACION_DAZN_CREA;
      aliasActivacionFaqs = MODULO_FAQS_ACTIVACION_DAZN_CREA;
      aliasCuentaCreada = MODULO_BUYBOX_CARACTERISTICS_CUENTA_CREADA_DAZN;
      aliasCuentaCreadaFaqs = MODULO_FAQS_CUENTA_CREADA_DAZN;
      aliasSinCuenta = MODULO_BUYBOX_CARACTERISTICS_SIN_CUENTA_DAZN;
      break;
    case "max":
      alias = ALIAS_HBO_MAX_ACTIVATION;
      aliasActivacion = MODULO_BUYBOX_CARACTERISTICS_ACTIVACION_HBO_CREA;
      aliasActivacionFaqs = MODULO_FAQS_ACTIVACION_HBO_CREA;
      aliasCuentaCreada = MODULO_BUYBOX_CARACTERISTICS_CUENTA_CREADA_HBO;
      aliasSinCuenta = MODULO_BUYBOX_CARACTERISTICS_SIN_CUENTA_HBO;
      break;
    case "skyshowtime":
      alias = ALIAS_SKYSHOWTIME_ACTIVATION;
      aliasActivacion = MODULO_BUYBOX_CARACTERISTICS_ACTIVACION_SKYSHOWTIME_CREA;
      aliasActivacionFaqs = MODULO_FAQS_ACTIVACION_SKYSHOWTIME_CREA;
      aliasCuentaCreada = MODULO_BUYBOX_CARACTERISTICS_CUENTA_CREADA_SKYSHOWTIME;
      aliasSinCuenta = MODULO_BUYBOX_CARACTERISTICS_SIN_CUENTA_SKYSHOWTIME;
      aliasCuentaCreadaFaqs = MODULO_FAQS_CUENTA_CREADA_SKYSHOWTIME_CREA;
      break;
    default:
      alias = "";
  }
  return {
    alias,
    aliasActivacion,
    aliasActivacionFaqs,
    aliasCuentaCreada,
    aliasCuentaCreadaFaqs,
    aliasSinCuenta,
  };
};

export const findProductsWithCertainProductOfferingDependency = (
  products,
  poId
) => {
  const filteredProducts = [];
  if (products && Array.isArray(products) && products.length > 0) {
    filteredProducts.push(
      ...products.filter((p) => {
        let includeCertainPOId = false;
        const { productosContratadosDedependientes } = p;
        if (
          productosContratadosDedependientes &&
          Array.isArray(productosContratadosDedependientes)
        ) {
          includeCertainPOId = productosContratadosDedependientes.some(
            (product) => product.poId === poId || product.bundleId === poId
          );
        }
        return includeCertainPOId;
      })
    );
  }
  return filteredProducts;
};

export const findProductWithCertainProductDependency = (
  products,
  productId
) => {
  let productFound = null;
  if (products && Array.isArray(products) && products.length > 0) {
    productFound = products.find((p) => {
      let includeCertainPOId = false;
      const { productosContratadosDedependientes } = p;
      if (
        productosContratadosDedependientes &&
        Array.isArray(productosContratadosDedependientes)
      ) {
        includeCertainPOId = productosContratadosDedependientes.some(
          (product) => product.productId === productId
        );
      }
      return includeCertainPOId;
    });
  }
  return productFound;
};

export const getClientMobileLines = (hiredProducts) => {
  const mobileArray = [];

  hiredProducts.forEach((hiredProduct) => {
    const { mobile } = hiredProduct;
    if (mobile && mobile.linesMobile && Array.isArray(mobile.linesMobile)) {
      hiredProduct.mobile.linesMobile.forEach((line) => {
        mobileArray.push(line);
      });
    }
  });
  return mobileArray;
};

export const getLinePhoneOfCertainProduct = (product) => {
  let number = "";
  if (product) {
    const { phone } = product;
    if (phone) {
      const { linesPhone } = phone;
      if (linesPhone && Array.isArray(linesPhone)) {
        const [linePhone] = linesPhone;
        if (linePhone) {
          ({ number } = linePhone);
        }
      }
    }
  }
  return number;
};

export const getDadByProductId = (hiredProducts, productId) => {
  let dadFound = hiredProducts.find((x) => x.productId === productId);
  if (!dadFound) {
    hiredProducts.forEach((hiredProduct) => {
      const { internet, mobile, phone, tv } = hiredProduct;
      if (internet && !dadFound) {
        if (internet.productId === productId) {
          dadFound = hiredProduct;
        } else {
          const productFound = getInternetProductsDependency(hiredProduct).find(
            (x) => x.productId === productId
          );
          if (productFound) {
            dadFound = hiredProduct;
          }
        }
      }
      if (mobile && !dadFound) {
        const { linesMobile } = mobile;
        if (linesMobile && Array.isArray(linesMobile)) {
          const productFound = linesMobile.find(
            (x) => x.productId === productId
          );
          if (productFound) {
            dadFound = hiredProduct;
          }
        }
        if (!dadFound) {
          const productFound = getMobileProductsDependency(hiredProduct).find(
            (x) => x.productId === productId
          );
          if (productFound) {
            dadFound = hiredProduct;
          }
        }
      }
      if (phone && !dadFound) {
        const { linesPhone } = phone;
        if (linesPhone && Array.isArray(linesPhone)) {
          const productFound = linesPhone.find(
            (x) => x.productId === productId
          );
          if (productFound) {
            dadFound = hiredProduct;
          }
        }
        if (!dadFound) {
          const productFound = getPhoneProductsDependency(hiredProduct).find(
            (x) => x.productId === productId
          );
          if (productFound) {
            dadFound = hiredProduct;
          }
        }
      }
      if (tv && !dadFound) {
        if (tv.productId === productId) {
          dadFound = hiredProduct;
        } else {
          const productFound = getTvProductsDependency(hiredProduct).find(
            (x) => x.productId === productId
          );
          if (productFound) {
            dadFound = hiredProduct;
          }
        }
      }
    });
  }
  return dadFound;
};

export const getLandlineConfigurationProducts = ({
  linePhone,
  hiredProducts,
  productId,
}) => {
  const currentLineProducts =
    linePhone?.productosContratadosDedependientes || [];

  if (currentLineProducts.length > 0) {
    return currentLineProducts;
  }

  return getPhoneProductsDependency(getDadByProductId(hiredProducts, productId));
};

export const getLandlineConfigurationSummary = ({
  myLineDetailMobileRestrictionStatus,
  linePhone,
  hiredProducts,
  productId,
  phoneConfigLiterals,
  phoneServiceIdToPoid,
}) => {
  const configurationList = Object.keys(
    myLineDetailMobileRestrictionStatus || {}
  ).map((id) => myLineDetailMobileRestrictionStatus[id].name);
  const uniqueTitles = new Set(configurationList);
  const products = getLandlineConfigurationProducts({
    linePhone,
    hiredProducts,
    productId,
  });

  products.forEach((item) => {
    const key = findKeyByIdRestriction(item?.poId, phoneServiceIdToPoid);
    if (phoneConfigLiterals[key]) {
      uniqueTitles.add(phoneConfigLiterals[key].title);
    }
  });

  return [...uniqueTitles];
};

export const getLinesMobileFromHiredProduct = (hiredProduct) => {
  const linesMobiles =
    hiredProduct &&
    hiredProduct.mobile &&
    Array.isArray(hiredProduct.mobile.linesMobile) &&
    hiredProduct.mobile.linesMobile.length > 0 &&
    hiredProduct.mobile.linesMobile.map((element) => {
      return element;
    });
  return linesMobiles;
};

export const isProductRent2Rent = (product, returnBoolean = false) => {
  let isMobileRent2Rent = false;
  let isMobileAdditionalRent2Rent = false;
  if (product) {
    isMobileRent2Rent =
      product.categorias &&
      product.categorias.tipoDispositivo === rent2rent.devicesTypeR2R;
    isMobileAdditionalRent2Rent =
      product.categorias &&
      product.categorias.tipoDispositivo === rent2rent.devicesTypeAdditionalR2R;
  }
  if (returnBoolean) {
    return isMobileRent2Rent || isMobileAdditionalRent2Rent;
  }
  return { isMobileRent2Rent, isMobileAdditionalRent2Rent };
};

/**
 * Method that return hiredProducts filtered by received productType param
 * @param {array} hiredProducts
 * @param {array} productsTypeFilter
 */
export const filterHiredProductsByProductsType = (
  hiredProducts,
  productsTypes
) => {
  let hiredProductsFilterd = [];
  if (hiredProducts && Array.isArray(hiredProducts)) {
    hiredProductsFilterd = hiredProducts.filter((element) =>
      productsTypes.includes(element.productType)
    );
  }
  return hiredProductsFilterd;
};

/**
 * Method that return Lines phones of a list of products
 * @param {array} hiredProducts
 * @param {array} productsTypes
 */
export const getClientLandLinesPhonesByProductsType = (
  hiredProducts,
  productsTypes
) => {
  const hiredProductsFilterd = filterHiredProductsByProductsType(
    hiredProducts,
    productsTypes
  );
  const phones = [];

  hiredProductsFilterd.forEach((item) => {
    if (
      item &&
      item.phone?.linesPhone &&
      Array.isArray(item.phone.linesPhone) &&
      item.phone.linesPhone.length > 0
    ) {
      phones.push(...item.phone.linesPhone);
    }
  });
  return phones;
};
export const getProductTextByDad = (idProducts, hireProduct) => {
  const arrayProductText = [];
  idProducts.forEach((idProduct) => {
    const product = getProductAndDadByProductId(hireProduct, idProduct);
    arrayProductText.push(product.product);
  });
  return arrayProductText;
};

export const getMobileRestrictionEventToDataLayer = (restriction) => {
  let eventToDataLayer = "";
  if (restriction) {
    switch (restriction.idRestriccion) {
      case "2":
      case "4":
      case "6":
      case "8":
      case "9":
      case "10":
      case "17":
      case "51":
      case "68":
        eventToDataLayer =
          "Servicios Llamadas - Restriccion de llamadas, datos y roaming";
        break;
      case "13":
      case "14":
      case "15":
      case "18":
      case "20":
      case "73":
        eventToDataLayer =
          "Servicios Llamadas - Restriccion de llamadas y mensajeria premium";
        break;
      case "7":
        eventToDataLayer = "Servicios Llamadas - Suspension de linea";
        break;
      default:
        eventToDataLayer = "Servicios Llamadas - NO TRATADO";
    }
  }
  return eventToDataLayer;
};

export const getMobileConfigurationEventToDataLayer = (
  diversionTypeToChange
) => {
  let eventToDataLayer = "";
  if (diversionTypeToChange) {
    switch (diversionTypeToChange) {
      case "buzon":
        eventToDataLayer = "Servicios Llamadas - Buzon de Voz";
        break;
      case "perdidas":
        eventToDataLayer = "Servicios Llamadas - Aviso de Llamadas Perdidas";
        break;
      case "desvio":
        eventToDataLayer = "Servicios Llamadas – Desvio de Llamadas";
        break;
      case "ocultacion":
        eventToDataLayer = "Servicios Llamadas – Ocultacion de Identidad";
        break;
      default:
        eventToDataLayer = "Servicios Llamadas – NO TRATADO";
    }
  }
  return eventToDataLayer;
};

/* PROMO 50GB START */
export const getlinesWithout30GbPromoForHired = (hiredProduct) => {
  const lineWithoutBonusHired = [];
  hiredProduct.forEach((product) => {
    if (product.mobile && product.mobile.linesMobile) {
      product.mobile.linesMobile.forEach((line) => {
        if (line && line.bonus) {
          line.bonus.forEach((bonu) => {
            if (
              bonu.free &&
              bonu.productOffering === poLibrary.bonuPromo30GB &&
              bonu.promoted
            ) {
              if (bonu.productId === null) {
                lineWithoutBonusHired.push(line);
              }
            }
          });
        }
      });
    }
  });
  return lineWithoutBonusHired;
};

export const hasAllLines30GbPromoHired = (hiredProduct) => {
  let allLineshas30GBBonus = true;
  hiredProduct.forEach((product) => {
    if (product.mobile && product.mobile.linesMobile) {
      product.mobile.linesMobile.forEach((line) => {
        let lineHas30Gb = false;
        if (line && line.bonus) {
          line.bonus.forEach((bonu) => {
            if (
              bonu.free &&
              bonu.productOffering === poLibrary.bonuPromo30GB &&
              bonu.productId
            ) {
              lineHas30Gb = true;
            }
          });
        }
        if (!lineHas30Gb) {
          allLineshas30GBBonus = false;
        }
      });
    }
  });

  return allLineshas30GBBonus;
};

export const hasAnyLine5GbPromoHired = (hiredProduct) => {
  let anyLine5GbBonus = false;
  hiredProduct.forEach((product) => {
    if (product.mobile && product.mobile.linesMobile) {
      product.mobile.linesMobile.forEach((line) => {
        if (line && line.bonus) {
          line.bonus.forEach((bonu) => {
            if (
              bonu.free &&
              bonu.productOffering === poLibrary.bonuPromo5GB &&
              bonu.productId != null
            ) {
              anyLine5GbBonus = true;
            }
          });
        }
      });
    }
  });
  return anyLine5GbBonus;
};

export const checkIfItBallHasBadge = (myAccumulatedUsages, productIdAux) => {
  let badge = false;
  if (myAccumulatedUsages) {
    // oBTENGO EL CONSUMO AL QUE HACE REFERENCIA
    const productaccumulatedUsage = getAccumulatedUsageByProductId(
      myAccumulatedUsages,
      productIdAux
    );
    if (productaccumulatedUsage) {
      const { totalExtra } = productaccumulatedUsage;
      badge = totalExtra > 0;
    }
  }
  return badge;
};

/** Checks if a bundle phone hired
 * @param {object} hiredProduct Client's product to be checked
 * @param {array} myAccumulatedUsages Usages accumulated
 * @returns {object} Object to show the phone ball
 */
export const getPhoneBall = (hiredProduct, myAccumulatedUsages) => {
  if (hiredProduct.phone && hiredProduct.phone !== null) {
    const { productId, number } = hiredProduct.phone.linesPhone[0];
    const badge = checkIfItBallHasBadge(myAccumulatedUsages, productId);
    const phoneBallItem = {
      id: productId,
      // label: `Fijo<br/>${number}`,
      label: "Fijo",
      svgIcon: "Fijo",
      wrapperClass: "blueBall",
      product: "phone",
      badge,
      phone: number,
      contracted: true,
    };

    return phoneBallItem;
  }
  return null;
};

/* get the product relative to a idProduct GETS A BUNDLE BAD NAME */
export const getProductById = (hiredProducts, productId) => {
  const product =
    hiredProducts &&
    hiredProducts.find((hireProduct) => {
      return hireProduct.productId === productId;
    });
  return product;
};

export const getFirstProductByPoIdOnMobileLinesOfProduct = (
  productStructure,
  poIds
) => {
  let product = null;
  if (productStructure) {
    const { mobile } = productStructure;
    if (mobile && !product) {
      const { linesMobile } = mobile;
      if (linesMobile && Array.isArray(linesMobile)) {
        const productFound = linesMobile.find((x) => poIds.includes(x.poId));
        if (productFound) {
          product = productFound;
        }
      }
      if (!product) {
        const productFound = getMobileProductsDependency(productStructure).find(
          (x) => poIds.includes(x.poId)
        );
        if (productFound) {
          product = productFound;
        }
      }
    }
  }

  return product;
};
export const getInternetFromProductId = (hiredProducts, productId) => {
  const product = getProductById(hiredProducts, productId);
  if (product) {
    const { internet } = product;
    return internet;
  }
  return null;
};

export const getInternetTypeFromProductId = (hiredProducts, productId) => {
  const internet = getInternetFromProductId(hiredProducts, productId);
  if (internet) {
    const { internetType } = internet;
    return internetType;
  }
  return null;
};

const RADIO_LANDLINE_INTERNET_TYPES = ["UNKNOWN"];

export const getInternetTypeByLandlineProductId = (hiredProducts, productId) => {
  const dadProduct = getDadByProductId(hiredProducts, productId);
  return dadProduct?.internet?.internetType || null;
};

export const shouldSkipRestrictionsRequest = ({
  hiredProducts,
  productId,
  phoneType,
}) => {
  if (phoneType !== FIJO || !Array.isArray(hiredProducts) || !productId) {
    return false;
  }

  const internetType = getInternetTypeByLandlineProductId(
    hiredProducts,
    productId
  );

  if (typeof internetType !== "string") {
    return false;
  }

  return RADIO_LANDLINE_INTERNET_TYPES.includes(internetType.toUpperCase());
};

export const getInternetDeviceFromProductId = (hiredProducts, productId) => {
  const internet = getInternetFromProductId(hiredProducts, productId);
  if (internet) {
    const { device } = internet;
    return device;
  }
  return null;
};

export const getPrincipalProductByHiredProducts = (hiredProducts) => {
  let principalProduct = null;
  if (Array.isArray(hiredProducts) && hiredProducts.length > 0) {
    principalProduct = hiredProducts.find(
      (product) => product.productType === FUSION
    );
    if (!principalProduct) {
      principalProduct = hiredProducts.find(
        (product) => product.productType === TRIO
      );
    }
    if (!principalProduct) {
      principalProduct = hiredProducts.find(
        (product) => product.productType === DUO
      );
    }
    if (!principalProduct) {
      principalProduct = hiredProducts[0];
    }
  }
  return principalProduct;
};
export const isRestrictionByServiceId = (serviceId) => {
  if (
    serviceId === "roaming" ||
    serviceId === "numeros" ||
    serviceId === "bloqueo" ||
    serviceId === "pukimei" ||
    serviceId === "puk" ||
    serviceId === "imei" ||
    serviceId === "emotion"
  ) {
    return true;
  }
  return false;
};
export const isPukImei = (serviceId) => {
  if (serviceId === "pukimei" || serviceId === "puk" || serviceId === "imei") {
    return true;
  }
  return false;
};

/* Get internet type on one fusion */
export const checkIfHasRouterHGU = (hiredProducts) => {
  let hasRouterHGU = false;
  hiredProducts.forEach((product) => {
    const { internet } = product;
    if (internet) {
      const { internetType, device } = internet;
      if (internetType === FIBER && device === HGU) {
        hasRouterHGU = true;
      }
    }
  });
  return hasRouterHGU;
};

export const getAllProductToUsages = (hiredProducts) => {
  const productsToUsages = [];
  if (
    hiredProducts &&
    Array.isArray(hiredProducts) &&
    hiredProducts.length > 0
  ) {
    hiredProducts.forEach((product) => {
      const { productType } = product;
      if (
        [FUSION, TRIO, DUO, ONLY_MOBILE, ONLY_PHONE].indexOf(productType) !== -1
      ) {
        productsToUsages.push(product);
      }
    });
  }
  return productsToUsages;
};

export const getFirstLinePhoneFromProductId = (hiredProducts, productId) => {
  const product = getProductById(hiredProducts, productId);
  if (product && product.phone) {
    const { phone } = product;
    const { linesPhone } = phone;
    if (linesPhone && Array.isArray(linesPhone) && linesPhone.length > 0) {
      return linesPhone[0];
    }
  }
  return null;
};

export const hasHiredProductsByProductType = (hiredProducts, productTypes) => {
  let productByProductId = null;
  if (hiredProducts && Array.isArray(hiredProducts)) {
    productByProductId = hiredProducts.find(
      (product) => product.productType === productTypes
    );
  }
  return !!productByProductId;
};

export const getProductsInternetInProductBySubSection = (
  product,
  subsection
) => {
  let arraySectionProducts = [];
  if (product && product.internet) {
    const internetDependecy = getInternetProductsDependency(product).filter(
      (x) => x.subseccion === subsection
    );
    arraySectionProducts = [
      ...new Set([...arraySectionProducts, ...internetDependecy]),
    ];
  }
  return arraySectionProducts;
};

export const getProductsInLineMobileBySubSection = (product, subsection) => {
  let arraySectionProducts = [];
  if (
    product &&
    product.productosContratadosDedependientes &&
    Array.isArray(product.productosContratadosDedependientes) &&
    product.productosContratadosDedependientes.length > 0
  ) {
    const mobileDependecy = product.productosContratadosDedependientes.filter(
      (x) => x.subseccion === subsection
    );
    arraySectionProducts = [
      ...new Set([...arraySectionProducts, ...mobileDependecy]),
    ];
  }
  return arraySectionProducts;
};

export const findPhonesNumbersByProductId = ({ hiredProducts, productId }) => {
  if (hiredProducts && productId) {
    const product = hiredProducts.filter(
      (item) => item.productId === productId
    );
    const cndHasSinglePhoneLine =
      Array.isArray(product) &&
      product.length > 0 &&
      product[0]?.mobile?.linesMobile &&
      product[0]?.phone?.linesPhone;
    if (cndHasSinglePhoneLine) {
      const productBase = product[0];
      return {
        mobile: productBase?.mobile?.linesMobile?.[0]?.number,
        fijo: productBase?.phone?.linesPhone?.[0]?.number,
      };
    }
  }
  return null;
};

export const generateFullNameDistriProduct = ({
  name,
  hiredProducts,
  productId,
  reverse = false,
}) => {
  const lines = findPhonesNumbersByProductId({ hiredProducts, productId });
  if (lines && name) {
    const line = lines?.fijo || lines?.mobile;
    if (reverse) {
      return `${line} - ${name}`;
    } else {
      return `${name} - ${line}`;
    }
  }
  return name;
};

export const hasAnyProductInArray = (hiredProducts, arrayToSearch) => {
  let hasAnyProduct = false;
  if (
    hiredProducts &&
    Array.isArray(hiredProducts) &&
    hiredProducts.length > 0 &&
    arrayToSearch &&
    Array.isArray(arrayToSearch) &&
    arrayToSearch.length > 0
  ) {
    hasAnyProduct = hiredProducts.some((product) =>
      arrayToSearch.includes(product.poId)
    );
  }
  return hasAnyProduct;
};

export const getRemainingQuotes = ({ endDate }) => {
  if (!endDate) return 0;

  // endDate en formato "dd/mm/yyyy"
  const [day, month, year] = endDate.split("/").map(Number);
  const finalDate = new Date(year, month - 1, day);

  const today = new Date();

  // Si ya pasó la fecha de vencimiento → 0 cuotas
  if (today > finalDate) return 0;

  // Calcular meses restantes considerando días
  let monthsRemaining =
    (finalDate.getFullYear() - today.getFullYear()) * 12 +
    (finalDate.getMonth() - today.getMonth());

  // Si el día del mes de hoy es menor o igual al día de vencimiento,
  // entonces hay que contar el mes actual
  if (today.getDate() <= finalDate.getDate() && monthsRemaining < 48) {
    monthsRemaining += 1;
  }

  return monthsRemaining;
};


export const getNameR2ROrionOrCatalogue = ({imagesR2R, idPO, catalogueProductOffering}) => {
  let name = null;
  if (imagesR2R && imagesR2R[idPO] && imagesR2R[idPO].name) {
    name = imagesR2R[idPO].name
  } else if (
    catalogueProductOffering &&
    catalogueProductOffering[idPO]?.texts
  ) {
    catalogueProductOffering[idPO]?.texts.forEach(
      (item) => {
        if (item?.typeId === TEXT_TYPES_CODES.ORDINARY && item?.text) {
          name = item?.text;
        }
      }
    );
  }
  return name;
}

export const getImagesR2ROrionOrCatalogue = ({imagesR2R, idPO, catalogueProductOfferingAttachments}) => {
  let image = null;
  let imageB64 = null;
  if (imagesR2R && imagesR2R[idPO] && imagesR2R[idPO].image) {
    image = imagesR2R[idPO].image;
  } else if (
    catalogueProductOfferingAttachments &&
    catalogueProductOfferingAttachments[idPO]?.attachments
  ) {
    catalogueProductOfferingAttachments[idPO]?.attachments.forEach(
      (item) => {
        if (
          item?.attachmentType?.id ===
          ATTACHMENTS_TYPES_IMG_HIGH_RESOLUTION &&
          item?.content
        ) {
          const normalizerImage = normalizeBase64ImageToCss(item?.content);
          imageB64 = normalizerImage;
        }
      }
    );
  }
  return {image, imageB64};
}

export const addR2RCard = ({ cards, products, type, catalogueProductOffering, catalogueProductOfferingAttachments, imagesR2R }) => {
  if (products && Array.isArray(products) && products.length > 0) {
    products.forEach((device) => {
      const { poId } = device;
      // const quoteNormalize = normalizeQuoteR2R(cuotaActualConPrecio);
      // let hideQuota = false;
      // Logica para ocultar la cuota para los dispositivos cuya fecha de inicio es menor que el "20-12-2023" (fecha dada por negocio)
      // if (fechaInicio && type == r2rHiredTypes.included) {
      //   const hasProductInArray = hasAnyProductInArray(
      //     hiredProducts,
      //     idPosOcultarCuotaR2RIncluido
      //   );
      //   const targetDate = new Date("2023-12-20");
      //   const fechaI = new Date(fechaInicio);
      //   hideQuota = hasProductInArray && targetDate > fechaI;
      // }
      // Logica para imagen
      const nameSelected = getNameR2ROrionOrCatalogue({idPO: poId, imagesR2R, catalogueProductOffering});
      const imageSelected = getImagesR2ROrionOrCatalogue({idPO: poId, imagesR2R, catalogueProductOfferingAttachments});
      const { image, imageB64 } = imageSelected;

      // Añadimos el dispositivo al array de cards 
      const card = {
        idPO: poId,
        name: nameSelected,
        image,
        imageB64,
        type,
      };
      cards.push(card);
    });
  }
  return cards;
}

export const generateCardR2R = ({
  mobilesIncludedRent2Rent,
  mobilesAditionalRent2Rent,
  catalogueProductOffering,
  catalogueProductOfferingAttachments,
  imagesR2R,
}) => {
  let cards = [];
  // Añado las cards dispositivos
  cards = addR2RCard({ cards, products: mobilesIncludedRent2Rent, type: r2rHiredTypes.included, catalogueProductOffering, catalogueProductOfferingAttachments, imagesR2R })
  cards = addR2RCard({ cards, products: mobilesAditionalRent2Rent, type: r2rHiredTypes.additional, catalogueProductOffering, catalogueProductOfferingAttachments, imagesR2R })

  return cards;
};

export const getChildProductByProductId = (hiredProducts, productId) => {
  let childProductFound = null;

  if (
    hiredProducts &&
    Array.isArray(hiredProducts) &&
    hiredProducts.length > 0
  ) {
    hiredProducts.forEach((product) => {
      const { childProductId } = product;
      if (
        childProductId &&
        Array.isArray(childProductId) &&
        childProductId.length > 0 &&
        !childProductFound
      ) {
        childProductFound = childProductId.find(
          (childProduct) => childProduct.productId === productId
        );
      }
    });
  }
  return childProductFound;
};

export const linkToRedirect = (
  id,
  PODestino,
  subtype,
  productOfferingCategoriesId,
  alias = null
) => {
  const { origin } = window.location;
  let linkRedirect = "";
  if (origin.indexOf("movistar.es.inte") > -1) {
    linkRedirect = "https://www.movistar.es.inte";
  } else if (origin.indexOf("movistar.es.cert") > -1) {
    linkRedirect = "https://www.movistar.es.cert";
  } else {
    linkRedirect = "https://www.movistar.es";
  }
  linkRedirect += "/order/telco/gp/activar-linea-movil";
  linkRedirect = concatUrl(linkRedirect, `productOffering=${PODestino}`);
  if (
    id &&
    subtype &&
    productOfferingCategoriesId !== CAT_NETFLIX &&
    productOfferingCategoriesId !== CAT_DISNEY
  ) {
    // NETFLIX O DISNEY
    linkRedirect = concatUrl(linkRedirect, `parentProductId=${id}`);
    linkRedirect = concatUrl(linkRedirect, `subType=${subtype}`);
  }
  if (alias) {
    let aliasFormated = alias;
    aliasFormated = aliasFormated.replaceAll(" ", "");
    aliasFormated = aliasFormated.replaceAll("#", "");

    linkRedirect = concatUrl(
      linkRedirect,
      `alias=${aliasFormated}`
    );
  }
  return linkRedirect;
};

export const getPromotionalInfoByProduct = (hiredProduct) => {
  let promotionalInfo = null;
  if (hiredProduct) {
    const { promotions } = hiredProduct;

    let promotionalText = "";
    let promotionEndDate = "";

    if (promotions && Array.isArray(promotions) && promotions.length === 1) {
      const [promoInfo] = promotions;
      const { fechaFin, expire, programmed } = promoInfo;
      promotionalText = getProductOfferingTextByType(
        promoInfo,
        TEXT_TYPES_CODES.BRIEF
      );
      if (fechaFin) {
        promotionEndDate = changeTelcoFormatToFrontFormat(fechaFin);
      }
      if (promotionEndDate) {
        promotionalInfo = {
          text: promotionalText,
          endDate: promotionEndDate,
          expire,
          programmed,
        };
      }
    }
  }
  return promotionalInfo;
};

export const getPackDate = ({ hiredProducts, productId }) => {
  if (hiredProducts && productId) {
    const product = hiredProducts.filter(
      (product) => product.productId === productId
    );
    if (product && product[0] && product[0].startDate) {
      const date = new Date(product[0].startDate);
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    }
  }
};

export const getFttrProducts = ({ hiredProducts }) => {
  if (Array.isArray(hiredProducts) && hiredProducts.length > 0) {
    const auxFttrProducts = hiredProducts.filter(
      (product) => product.productOfferingCategory === FTTR_PO_CATEGORY,
    );
    return Array.isArray(auxFttrProducts) && auxFttrProducts.length > 0 && auxFttrProducts;
  }
};

export const hasRestrictionByIdRestriction = ({ myLineDetailMobileRestrictionStatus, idRestriction }) => {
  if (myLineDetailMobileRestrictionStatus && myLineDetailMobileRestrictionStatus[idRestriction]) {
    const restriction = myLineDetailMobileRestrictionStatus[idRestriction];
    return restriction && restriction.estado;
  }
}

export const canBeRenewed =({ poId, hiredR2R, isCancellable }) => {
  if (poId && hiredR2R && isCancellable) {
    return (hiredR2R === poId)
  }
}

export const hasOneBeRenewed = ({ hiredR2R, cards, isCancellable}) => {
  if (isCancellable && hiredR2R && cards && Array.isArray(cards) && cards.length > 0) {
    const device = cards.find((item) => item?.idPO === hiredR2R);
    return device;
  }
}

export const hasAppleDevice = (devices) => {
  if (devices && Array.isArray(devices) && devices.length > 0) {
    const keys = ["apple", "iphone", "ipad", "airpods","macbook"];
    const appleDevice = devices.find((device) => {
      if (device?.name) {
        return keys.find(key => device?.name.toLowerCase().includes(key)) !== undefined;
      }
    })
    return appleDevice && "Apple";
  }
  return null;
}


export const removeDecimals = (number) => {
  let numStr = number.toString();

  if (numStr.includes('.00')) {
    return parseInt(number);
  }

  return number;
};

const getMonthsToAdd = (text) => {
  let monthsToAdd = 24;
  if (Array.isArray(text) && text.length > 0) {
    const name = text.find((item) => item?.typeId === TEXT_TYPES_CODES.ORDINARY)?.text;
    const normalizedName = name?.toLowerCase() || "";
    const isMacBookOrIpad = normalizedName.includes("macbook") || normalizedName.includes("ipad");

    if (isMacBookOrIpad) {
      monthsToAdd = 36;
    }
  }
  return monthsToAdd;
}

export const getInfoMyProductsR2R = ({ myProductsR2R, type, idPO, hiredProducts }) => {
  if (myProductsR2R && type && idPO) {
    const { incluido, adicional } = myProductsR2R;
    let hideQuota = false;
    const hasProductInArray = hasAnyProductInArray(
      hiredProducts,
      idPosOcultarCuotaR2RIncluido
    );
    const targetDate = new Date("2025-04-03");
    if (type === r2rHiredTypes.included && incluido && Array.isArray(incluido) && incluido.length > 0) {
      const product = incluido.find((item) => item?.idPO === idPO);
      if (product) {
        const {fechaInicio, fechaVencimiento, cuotaActualConPrecio, text} = product;

        let isSwap = null;
        if (product?.productOfferingTypes && Array.isArray(product?.productOfferingTypes) && product?.productOfferingTypes.length > 0) {
          const swap = product?.productOfferingTypes.some((item) => (item?.id === "203" || item?.id === "202" || item?.id === "201"));
          isSwap = swap;
        }

        const quoteNormalize = normalizeQuoteR2R(cuotaActualConPrecio)
        const { price, unity } = quoteNormalize;
        // Logica para ocultar la cuota para los dispositivos cuya fecha de inicio es menor que el "03-04-2025" (fecha dada por negocio)
        if (fechaInicio && type == r2rHiredTypes.included) {
          const fechaI = new Date(fechaInicio);
          const swapDate = new Date(fechaInicio);
          hideQuota = hasProductInArray && targetDate > fechaI;
          const monthsToAdd = getMonthsToAdd(text);
          const swapMonths = swapDate.getMonth() + monthsToAdd;
          swapDate.setMonth(swapMonths);
          const formatShort = {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
          };
          const formatFull = {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
          };

          const swapDate_ES = swapDate.toLocaleDateString('es-ES', formatShort);
          const swapDate_ES_Long = swapDate.toLocaleDateString('es-ES', formatFull);

          return {
            price,
            unity,
            cuotaActualConPrecio,
            fechaInicio,
            fechaVencimiento,
            hideQuota,
            remainingQuotes: getRemainingQuotes({ endDate: fechaVencimiento }),
            isSwap,
            swapDate: swapDate_ES,
            swapDateFull: swapDate_ES_Long,
          }
        }
      }
    }
    if (type === r2rHiredTypes.additional && adicional && Array.isArray(adicional) && adicional.length > 0) {
      const product = adicional.find((item) => item?.idPO === idPO);
      if (product) {
        const { fechaInicio, fechaVencimiento, cuotaActualConPrecio, text } = product;

        let isSwap = null;
        if (product?.productOfferingTypes && Array.isArray(product?.productOfferingTypes) && product?.productOfferingTypes.length > 0) {
          const swap = product?.productOfferingTypes.some((item) => (item?.id === "203" || item?.id === "202" || item?.id === "201"));
          isSwap = swap;
        }

        const quoteNormalize = normalizeQuoteR2R(cuotaActualConPrecio)
        const { price, unity } = quoteNormalize;
        const fechaI = new Date(fechaInicio);
        const swapDate = new Date(fechaInicio);
        hideQuota = hasProductInArray && targetDate > fechaI;
        const monthsToAdd = getMonthsToAdd(text);
        const swapMonths = swapDate.getMonth() + monthsToAdd;
        swapDate.setMonth(swapMonths);
        const formatShort = {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
        };
        const formatFull = {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
        };

        const swapDate_ES = swapDate.toLocaleDateString('es-ES', formatShort);
        const swapDate_ES_Long = swapDate.toLocaleDateString('es-ES', formatFull);

        return {
          price,
          unity,
          fechaInicio,
          fechaVencimiento,
          hideQuota,
          remainingQuotes: getRemainingQuotes({ endDate: fechaVencimiento }),
          isSwap,
          swapDate: swapDate_ES,
          swapDateFull: swapDate_ES_Long,
        }
      }
    }
  }
}

export const findKeyByIdRestriction = (id, data) => {
  let result = null;
  Object.keys(data).forEach((key) => {
    if (data[key].includes(id)) {
      result = key;
    }
  });
  return result;
};

export const paintCardDevices = ({ clientType }) => {
  if (clientType && (clientType === USUARIO_R2R || clientType === USUARIO_PRIMER_R2R_INCLUIDO || clientType === USUARIO_R2R_ADICIONAL || clientType === USUARIO_SEGUNDO_R2R_INCLUIDO || clientType === USUARIO_R2R_ADICIONAL_REDIMIR)) {
    return true;
  } else {
    return false;
  }
}

export const haveNotDevices = ({ productCards }) => {
  if (productCards && Array.isArray(productCards) && productCards.length > 0) {
    const deviceCard = productCards.find((card) => card?.alias === AP_PRODUCT_CONTRATADOS_LIST_DISPOSITIVOS);
    if (deviceCard && deviceCard.products && Array.isArray(deviceCard.products) && deviceCard.products.length > 0) {
      return true;
    }
  }
  return false;
}

export const hasInternetProduct = ({ hiredProducts, dadProductId }) => {
  if (hiredProducts && Array.isArray(hiredProducts) && hiredProducts.length > 0 && dadProductId) {
    const currentProduct = getProductByProductId(hiredProducts, dadProductId);
    if (currentProduct && currentProduct.internet) {
      return true
    }
  }
  return null;
}

export const getSSOUrl = () => {
  let url = SSO_PDB_URL_PROD;
  const currentEnv = `${process.env.NEXT_PUBLIC_ENV_NAME}`;

  switch(currentEnv){
    case ENV_NAME.LOCAL:
    case ENV_NAME.CERT:
    case ENV_NAME.CODE:
      url = SSO_PDB_URL_CERT
      break;
    default:
      break;
  }

  return url;
}

export const paintCloudManagment = ({ hiredProducts }) => {
  let hasCloud = false;
  const mobileLines = getAllMobileLines(hiredProducts)
  const idPosCloud = SPECIFIC_CUSTOMER_PRODUCT_KINDS.CLOUD.prodOfferList;
  if (mobileLines && Array.isArray(mobileLines) && mobileLines.length > 0) {
    mobileLines.forEach((item) => {
      const currentProduct = getProductByProductId(hiredProducts, item?.productId);
      const productsBySecuritySubsection = getProductsInLineMobileBySubSection(
        currentProduct,
        CATALOG_SECTIONS.VERTICALS.SUB_SECTIONS.SECURITY
      );
      if (
        productsBySecuritySubsection &&
        Array.isArray(productsBySecuritySubsection) &&
        productsBySecuritySubsection.length > 0
      ) {
        hasCloud = productsBySecuritySubsection.some((product) =>
          idPosCloud.includes(product.poId)
        );
      }
    })
  }
  return hasCloud;
}

export const paintPerplexityPill = (hiredProductsList) => {
  let paint = false;
  if (
    hiredProductsList &&
    Array.isArray(hiredProductsList) &&
    hiredProductsList.length > 0 &&
    hiredProductsList.length !==
    getPrepagoLines(hiredProductsList).length +
    getEquipamientoProducts(hiredProductsList).length
  ) {
    paint = true
  }
  return paint;
}

export const hasEssentialProtection = ({ hiredProducts, hiredProductsList }) => {
  let hasSecureConnection = false;
  if (hiredProducts && Array.isArray(hiredProducts) && hiredProducts.length > 0) {
    hiredProducts.forEach((item) => {
      const currentProduct = getProductByProductId(hiredProducts, item?.productId);
      const productsBySecuritySubsection =
        getProductsInternetInProductBySubSection(
          currentProduct,
          CATALOG_SECTIONS.VERTICALS.SUB_SECTIONS.SECURITY
        );
      const hasDigitalProtectionEssential = productsBySecuritySubsection.some(
        (product) => product?.poId === "411"
      );
      if (hasDigitalProtectionEssential) {
        hasSecureConnection = true;
      }
    })
  }
  return hasSecureConnection;
}

export const paintSecureConnectionPill = ({ hiredProducts, hiredProductsList }) => {
  const hasDigitalProtection = hasEssentialProtection({ hiredProducts, hiredProductsList })
  const proteccionDigitalIntegralProducts  = getProteccioDigitalIntegralProducts(hiredProductsList);
  if (proteccionDigitalIntegralProducts   && Array.isArray(proteccionDigitalIntegralProducts) && proteccionDigitalIntegralProducts.length > 0) {
    return {link: `https://www.movistar.es/auth/sso/pdi?`, target: "_blank"}
  } else if (hasDigitalProtection) {
    return {link: `https://www.movistar.es/auth/sso/pdb?`, target: "_blank"}
  }
  return null;
}

export const equipmentCards = ({ hiredProducts, dadProductId, orionInfo, tv }) => {
  let resources = null;
  let cards = null;
  let contractedCards = null;
  if (hiredProducts && dadProductId && orionInfo) {
    const currentProduct = getProductByProductId(hiredProducts, dadProductId);
    if (tv) {
      resources = currentProduct?.tv?.resources;
      cards = orionInfo?.cards.filter((item) => item?.type === "tv");
    } else {
      resources = currentProduct?.internet?.resources;
      cards = orionInfo?.cards.filter((item) => item?.type === "internet");
    }
    return cards;
  }
}

export const getContractsTextsByProductId = ({ productId, listContractsById, hiredProducts}) => {
  if (!listContractsById || typeof listContractsById !== "object") {
    return null;
  }

  const data = Object.values(listContractsById);
  // Validar que tenga contenido
  if (data.length === 0) {
    return null;
  }


  let startDateNormalized = null;
  let labelEndDate = null;

  const contractInfo = listContractsById[productId];
  if (contractInfo?.contracts?.[0]?.terms?.[0]) {
    const { fechaInicio } = contractInfo.contracts[0].terms[0];
    let commitmentEndDate = null;
    const commitmentContracts = getProductContractsOfCertainPOTType(
      contractInfo?.contracts,
      PERMANENCE
    );
    const [contract] = commitmentContracts;
    if (contract) {
      commitmentEndDate = contract && contract[0] && contract[0].fechaFin;
    }
    labelEndDate = commitmentEndDate && `${withCommitmentTermPrefix}<span class="text-gp--font-bold">${commitmentEndDate}</span>`;
    startDateNormalized = fechaInicio;
  } else {
    const product = Array.isArray(hiredProducts) && hiredProducts.length > 0 && hiredProducts.find((item) => item?.productId === productId);
    startDateNormalized = product && product.startDate && changeTelcoFormatToFrontFormat(product.startDate).replace(/-/g, "/");
  }

  return startDateNormalized && { fechaInicio: `Fecha de contratación: <span class="text-gp--font-bold">${startDateNormalized}</span>`, labelEndDate }

}

export const showCerberusSection = (hiredProducts = [], info = {}) => {
  const someFusionOrOnlyMobile = hiredProducts.some(
    ({ productType } = {}) =>
      productType === FUSION || productType === ONLY_MOBILE
  );

  return someFusionOrOnlyMobile && hasAnyCompatibleMobileLine(info);
};
